export default __webpack_public_path__ + "static/grandangolo-1-7bd33386d7417cbcabdde513ec1df6bb.jpg";